"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Card;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const variables_1 = __importDefault(require("../../styles/variables"));
const Text_1 = __importDefault(require("../Text"));
const useStyles = (0, core_1.makeStyles)(() => ({
    card: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: variables_1.default.colors.base.white,
        listStyle: 'none',
        flexWrap: 'wrap',
        padding: '24px',
    },
    image: {
        maxWidth: '50%',
        height: 'auto',
        position: 'absolute',
        margin: 'auto',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    imageContainer: {
        width: '50%',
        height: '120px',
        margin: '0 auto',
        position: 'relative',
    },
}));
function Card({ image, title, description, name, designation, }) {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Card, { className: classes.card },
        react_1.default.createElement("div", { className: classes.imageContainer },
            react_1.default.createElement(core_1.CardMedia, { component: "img", image: image, className: classes.image })),
        react_1.default.createElement(core_1.CardHeader, { title: title, style: { color: variables_1.default.colors.base.info } }),
        react_1.default.createElement(core_1.CardContent, null,
            react_1.default.createElement(Text_1.default, { as: "p" }, description),
            react_1.default.createElement(Text_1.default, { as: "p", style: { lineHeight: variables_1.default.fonts.lineHeight.h1 } }, name),
            react_1.default.createElement(Text_1.default, { as: "p" }, designation))));
}
